module.exports = __webpack_public_path__ + "img/location@2x.f4ba6d1.jpg";